/**
 * admin/query-keys — TanStack Query key factory for the back-office panels.
 *
 * Same contract as `utils/query-keys.ts`: never inline string arrays at the call
 * site, always go through this factory so invalidation prefixes stay consistent
 * across the admin features (users, audit, integrations, flags, metrics).
 */

export interface AdminUsersFilter {
  q?: string;
  role?: string;
  page?: number;
}

export interface AdminAuditFilter {
  entityType?: string;
  action?: string;
  userId?: string;
  page?: number;
}

/** Filtro del catálogo de features (`admin.features`). */
export interface AdminFeaturesFilter {
  search?: string;
  category?: string;
  scope?: string;
  status?: string;
}

export const adminQueryKeys = {
  all: ["admin"] as const,
  users: (filter: AdminUsersFilter = {}) => ["admin", "users", filter] as const,
  audit: (filter: AdminAuditFilter = {}) => ["admin", "audit", filter] as const,
  // F2-D: las integraciones se resuelven por alcance (global si `orgId` ausente).
  integrations: (orgId?: string | null) => ["admin", "integrations", orgId ?? "global"] as const,
  // F2-D: catálogo de features auto-descriptivo.
  features: (filter: AdminFeaturesFilter = {}) => ["admin", "features", filter] as const,
  flags: () => ["admin", "flags"] as const,
  metrics: () => ["admin", "metrics"] as const,
  // F3-E: gestión de media (vídeos + uso por org).
  mediaVideos: (filter: { filter?: string; org?: string } = {}) =>
    ["admin", "media", "videos", filter] as const,
  mediaUsage: () => ["admin", "media", "usage"] as const,
};
